import { CategoryDisplayType, RelationshipTypeQuery } from 'src/graphql';

export const mapCategoriesToDefaultOptions = (
  categories:
    | CategoryDisplayType[]
    | RelationshipTypeQuery['getRelationshipType'],
) => {
  return categories?.map((category) => {
    const label = category.name ?? '';
    return {
      label,
      value: category.id,
    };
  });
};
